<template>
  <div>
    <b-form-group
      :label="$t('reusable.common.name')"
      label-for="input-name"
      label-cols="4"
      label-cols-sm="3"
      class="label"
    >
      <b-form-input
        id="input-name"
        name="input-name"
        v-model="$v.study_environment.name.$model"
        :state="validateState('name')"
        aria-describedby="input-name-live-feedback"
        size="sm"
      ></b-form-input>
      <b-form-invalid-feedback id="input-name-live-feedback">{{
        $t("reusable.common.minLength", { min: 3 })
      }}</b-form-invalid-feedback>
    </b-form-group>
    <b-form-group
      :label="$t('reusable.common.description')"
      label-for="input-description"
      label-cols="4"
      label-cols-sm="3"
      class="label"
    >
      <div
        class="form-description mb-2"
        @click="$bvModal.show(`edit-description-modal`)"
      >
        <RenderVHtml
          v-b-tooltip.v-secondary.noninteractive.hover="{
            title: $t('reusable.common.editDescription'),
            boundary: 'viewport',
          }"
          :content="study_environment.description"
        ></RenderVHtml>
      </div>
      <ContainerRichTextKlv3
        :id_modal="`edit-description-modal`"
        :title_modal="$t('reusable.common.editDescription')"
        :size_modal="`lg`"
        :object_rich_text="study_environment"
        :content_rich_text="study_environment.description"
        :show_last_modification="true"
        @save="(content) => patchDescription(study_environment, content)"
        @close="$bvModal.hide(`edit-description-modal`)"
      >
      </ContainerRichTextKlv3>
      <!-- <b-modal
        :id="`edit-description-modal`"
        title="Editar Descripción"
        size="lg"
        hide-footer
      >
        <NewRichTextEditor
          :Object="study_environment"
          :Text="study_environment.description"
          @save="patchDescription"
          @close="$bvModal.hide(`edit-description-modal`)"
        ></NewRichTextEditor>
      </b-modal> -->
      <!-- <b-form-textarea
        id="input-description"
        name="input-description"
        v-model="$v.study_environment.description.$model"
        :state="validateState('description')"
        aria-describedby="input-description-live-feedback"
        size="md"
        rows="3"
        max-rows="8"
      ></b-form-textarea> -->
      <b-form-invalid-feedback id="input-description-live-feedback">{{
        $t("reusable.common.minLength", { min: 5 })
      }}</b-form-invalid-feedback>
    </b-form-group>
    <SelectedStudyEnvironmentTimeAllocation
      :object_id="study_environment.id"
      :ViewTimeAllocation="false"
      @update_time_allocation="updateTimeAllocation"
      @remove_time_allocation="removeTimeAllocation"
    ></SelectedStudyEnvironmentTimeAllocation>
    <b-form-group
      v-if="!isNaN(this.study_environment.id)"
      label-for="input-modification-date"
      label-cols="0"
      label-cols-sm="0"
      class="p-0 m-0 mt-2"
    >
      <ModificationDate :Information="study_environment"></ModificationDate>
    </b-form-group>
    <div class="row">
      <div
        v-if="show_delete_button && !isNaN(this.study_environment.id)"
        class="col"
        style="text-align: left"
      >
        <b-button
          class="mr-1"
          size="sm"
          variant="danger"
          @click="deleteStudyEnvironment"
          >{{ $t("reusable.common.delete") }}</b-button
        >
      </div>
      <div v-if="show_save_button" class="col" style="text-align: right">
        <b-button class="m-0" size="sm" @click="save">{{
          $t("reusable.common.save")
        }}</b-button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { generateUniqueId } from "@/utils/utils";
import * as names from "@/store/names";
import { validationMixin } from "vuelidate";
import { required, minLength } from "vuelidate/lib/validators";
import { toast } from "@/utils/utils";
export default {
  name: "StudyEnvironmentForm",
  mixins: [validationMixin],
  components: {
    // NewRichTextEditor: () => import("@/components/reusable/NewRichTextEditor"),
    SelectedStudyEnvironmentTimeAllocation: () =>
      import("@/components/reusable/SelectedStudyEnvironmentTimeAllocation"),
    ModificationDate: () => import("@/components/reusable/ModificationDate"),
    ContainerRichTextKlv3: () =>
      import("@/components/reusable/ContainerRichTextKlv3"),
    RenderVHtml: () => import("@/components/reusable/RenderVHtml"),
  },
  props: {
    StudyEnvironment: {
      type: Object,
      default: function () {
        return {
          id: generateUniqueId(),
          name: "",
          description: "",
          creation_date: null,
          created_by: null,
          updated_by: null,
          update_date: null,
        };
      },
    },
    show_save_button: {
      type: Boolean,
      default: true,
    },
    show_delete_button: {
      type: Boolean,
      default: false,
    },
    show_title: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      study_environment: { ...this.StudyEnvironment },
      tmp_time_allocations: [],
    };
  },
  validations: {
    study_environment: {
      name: {
        required,
        minLength: minLength(3),
      },
      description: {},
    },
  },
  computed: {
    ...mapGetters({
      studyEnvironmentsTimeAllocation: names.STUDY_ENVIRONMENTS_TIME_ALLOCATION,
    }),
  },
  created() {},
  methods: {
    patchDescription(object, text) {
      this.study_environment.description = text;
    },
    validateState(name) {
      const { $dirty, $error } = this.$v.study_environment[name];
      return $dirty ? !$error : null;
    },
    updateTimeAllocation(time_allocations) {
      if (isNaN(this.study_environment.id)) {
        time_allocations.forEach((time_allocation) => {
          if (!this.tmp_time_allocations.includes(time_allocation))
            this.tmp_time_allocations.push(time_allocation);
        });
      } else if (!isNaN(this.study_environment.id)) {
        this.updateStudyEnvironmentTimeAllocation(time_allocations);
      }
    },
    async updateStudyEnvironmentTimeAllocation(time_allocations) {
      for await (let time_allocation of time_allocations) {
        await this.$store.dispatch(
          names.POST_STUDY_ENVIRONMENT_TIME_ALLOCATION,
          {
            study_environment: this.study_environment.id,
            time_allocation: time_allocation,
          }
        );
      }
    },
    removeTimeAllocation(time_allocation) {
      if (isNaN(this.study_environment.id)) {
        const index = this.tmp_time_allocations.findIndex(
          (x) => x == time_allocation
        );
        if (index != -1) this.tmp_time_allocations.splice(index, 1);
      } else {
        const study_environment_time_allocation =
          this.studyEnvironmentsTimeAllocation.find(
            (x) =>
              x.time_allocation == time_allocation &&
              x.study_environment == this.study_environment.id
          );
        if (study_environment_time_allocation)
          this.$store.dispatch(
            names.DELETE_STUDY_ENVIRONMENT_TIME_ALLOCATION,
            study_environment_time_allocation.id
          );
      }
    },
    save() {
      this.$v.study_environment.$touch();
      if (this.$v.study_environment.$anyError) {
        return;
      }
      if (isNaN(this.study_environment.id)) {
        this.createStudyEnvironment();
      } else this.updateStudyEnvironment();
    },
    createStudyEnvironment() {
      this.$store
        .dispatch(names.POST_STUDY_ENVIRONMENT, this.study_environment)
        .then((response) => {
          this.study_environment.id = response.id;
          if (this.tmp_time_allocations.length > 0)
            this.updateStudyEnvironmentTimeAllocation(
              this.tmp_time_allocations
            );
          toast(
            this.$t("reusable.common.created", {
              entity: this.$getVisibleNames(
                "mesh.studyenvironment",
                false,
                "Ambiente de Aprendizaje"
              ),
            })
          );
          this.$emit("created", response);
        });
    },
    updateStudyEnvironment() {
      this.$store
        .dispatch(names.UPDATE_STUDY_ENVIRONMENT, this.study_environment)
        .then((response) => {
          toast(
            this.$t("reusable.common.updated", {
              entity: this.$getVisibleNames(
                "mesh.studyenvironment",
                false,
                "Ambiente de Aprendizaje"
              ),
            })
          );
          this.$emit("updated", response);
        });
    },
    deleteStudyEnvironment() {
      this.$swal({
        title: this.$t("reusable.common.deleteConfirmTitle", {
          entity: this.$getVisibleNames(
            "mesh.studyenvironment",
            false,
            "Ambiente de Aprendizaje"
          ),
        }),
        text: this.$t("reusable.common.deleteConfirmText"),
        type: "warning",
        showCancelButton: true,
      }).then((result) => {
        if (result.value) {
          this.$store.dispatch(
            names.DELETE_STUDY_ENVIRONMENT,
            this.study_environment.id
          );
          this.$emit("deleted", this.study_environment);
        }
      });
    },
  },
};
</script>
<style scoped src="@/utils/rich_text_editor.css">
</style>
<style scoped>
.form-description {
  width: calc(100%);
  border: 1px solid #ced4da;
  border-radius: 4px;
  font-size: 0.875rem;
  min-height: calc(1.5em + 0.5rem + 2px);
  height: auto;
  max-height: 200px;
  overflow: auto;
  padding: 0.2rem 0.5rem;
  line-height: 1.5;
}
.form-description >>> p {
  margin-bottom: 0.7rem !important;
}
</style>